module.exports = __webpack_public_path__ + "static/Pit Pay Orange -ad09650de72561aa8b69022cdc376121.svg";